import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getUserChannels } from '../../../api/users';

import { logoutUser } from '../../auth/login/LoginSlice';
import { STATUS_CODE } from '../../../constants/statusCode';
import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { saveUserDataToCache } from '../../../utils/userCache';

export const fetchUserChannels = createAsyncThunk(
  'currentUser/fetchUserChannels',
  async (params, { signal, rejectWithValue, dispatch }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getUserChannels({
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      if (error.response?.status === STATUS_CODE.NOT_FOUND) {
        dispatch(logoutUser());
      }

      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchUserChannelsExtraReducers = builder => {
  builder
    .addCase(fetchUserChannels.pending, (state, action) => {
      checkAndSetLoading(state.userChannelsRequest, action);
    })
    .addCase(fetchUserChannels.fulfilled, (state, action) => {
      onMatchedRequest(state.userChannelsRequest, action, () => {
        state.channels = action.payload;
        const channelsByRoles = {};
        Object.entries(action.payload).map(([channel, roles]) =>
          roles.map(role => {
            if (!channelsByRoles[role]) {
              channelsByRoles[role] = [];
            }
            channelsByRoles[role].push(channel);
            return role;
          }),
        );
        state.channelsByRoles = channelsByRoles;

        saveUserDataToCache(
          {
            channels: state.channels,
            channelsByRoles: state.channelsByRoles,
          },
          'channels',
        );
      });
    })
    .addCase(fetchUserChannels.rejected, (state, action) => {
      handleRequestRejection(state.userChannelsRequest, action);
    });
};
